import { render } from "./SubcategoryPage.vue?vue&type=template&id=7bd42dfc&scoped=true"
import script from "./SubcategoryPage.vue?vue&type=script&lang=js"
export * from "./SubcategoryPage.vue?vue&type=script&lang=js"

import "./SubcategoryPage.vue?vue&type=style&index=0&id=7bd42dfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd42dfc"]])

export default __exports__